import { planTypes } from "@/common/constants";


export const computedWebinarPlans = plans => plans.filter(item => item.type === planTypes.WEBINAR);
export const computedAnnualWebinarPlans = plans => computedWebinarPlans(plans).filter(item => item.billing_cycle === 'annual');
export const computedMonthlyWebinarPlans = plans => computedWebinarPlans(plans).filter(item => item.billing_cycle === 'monthly');
export const computedOneMonthWebinarPlans = plans => computedWebinarPlans(plans).filter(item => item.billing_cycle === 'one_month');
export const computedCapacityWebinarPlans = (plans, capacity) => computedWebinarPlans(plans).filter(item => item.participants === capacity);
